import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
function useDebounceCallback(callback, delay) {
    const timeoutRef = (0, __WEBPACK_EXTERNAL_MODULE_react__.useRef)();
    const debouncedCallback = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(()=>{
            callback(...args);
        }, delay);
    }, [
        callback,
        delay
    ]);
    return debouncedCallback;
}
export { useDebounceCallback };
